import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { SelectField, MenuItem, TextField } from 'material-ui';
import { colors } from '../../../utils';

const CheckboxFields = ({ field, onChange }) => {
  const [checked, setChecked] = useState(false);
  const [radioButtonGroup, setRadioButtonGroup] = useState('');

  useEffect(() => {
    if (!checked || checked !== field.checked) {
      setChecked((field && field.checked) || false);
    }
    if (!radioButtonGroup || radioButtonGroup !== field.radio_button_group_id) {
      setRadioButtonGroup(field && field.radio_button_group_id);
    }
  });


  return (
    <Container>
      <InputContent>
        <div>Default Value</div>
        <div>
          <SelectField
            dropDownMenuProps={{
                    getContentAnchorEl: null,
                    anchorOrigin: {
                      vertical: 'bottom',
                      horizontal: 'left',
                    },
                  }}
            value={checked}
            onChange={(event, index, val) => onChange('checked', val > 0)}
          >
            <MenuItem
              value={false}
              primaryText="Unselected"
            />
            <MenuItem
              value
              primaryText="Selected"
            />
          </SelectField>
        </div>
      </InputContent>
      <InputContent>
        <div>Radio Button Group</div>
        <div>
          <TextField
            fullWidth
            type="number"
            value={radioButtonGroup}
            onChange={(e, val) => onChange('radio_button_group_id', val)}
          />
        </div>
      </InputContent>
    </Container>
  );
};


CheckboxFields.propTypes = {
  field: PropTypes.any,
  onChange: PropTypes.func,
};

CheckboxFields.defaultProps = {
  field: {},
  onChange: () => {},
};

const InputContent = styled.div`
  color: ${colors.defaultImageGray};
  display: flex;
  & > div {
    display: flex;
    flex: 1;
    justify-content: flex-start;
    align-items: center;
  }
`;

const Container = styled.div`
  width: 100%;

  & label {
    color: ${colors.defaultImageGray} !important;
  }
`;

export default CheckboxFields;
